// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"vr_main-wrapper__3EVAO","panorama-viewer":"vr_panorama-viewer__3xwaZ","progress-bar":"vr_progress-bar__2UlZq","finish":"vr_finish__1haqW"};